// src/store/auth.js
import axios from 'axios'
import { defineStore } from "pinia"

// import { useRouter } from 'vue-router'

// const router = useRouter()

// "user": {
//   "id": 94,
//   "name": "versiduwer",
//   "email": "zaidi@versiduwer.com",
//   "email_verified_at": null,
//   "created_at": "2024-04-23T16:23:47.000000Z",
//   "updated_at": "2024-04-23T16:23:47.000000Z"
// }

const loginApiUrl = import.meta.env.VITE_LOGIN_API_URL;

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: localStorage.getItem("token") || "",
    user: JSON.parse(localStorage.getItem("user")) || null,
    roles: localStorage.getItem("roles") || "",
  }),

  //=========================== Getters ==============================

  getters: {
    isAuthenticated: state => !!state.token,
  },

  //=========================== Actions ==============================

  actions: {


   
    async login(email, password) {
      try {
        const response = await axios.post(`${loginApiUrl}login`, { 
          email,
          password,
        })

        this.token = response.data.token
        this.user = response.data.user
        localStorage.setItem('token', this.token)

        return response
      } catch (error) {
        console.error('Login error:', error)
        throw error
      }
    },
   

    loadToken() {
      const storedToken = localStorage.getItem('token')
      if (storedToken) {
        this.token = storedToken
      }
    },

    // How to use => authStore.logout(router)

    // logout(router) {
    //   this.token = null
    //   this.user = null
    //   this.clearToken()
    //   router.push('/')
    // },

    logout(router) {
      this.token = null
      this.user = null
      this.clearToken()
      router.push('/login')
    },

    setToken(token) {
      this.token = token
      localStorage.setItem("token", token)
    },
    setRoles(data) {
      localStorage.setItem("roles", JSON.stringify(data.roles)) // Convert array to JSON string
      this.roles = JSON.stringify(data.roles)
      // Hardcode manager role
      // const roles = ["manager"]
      // const rolesJson = JSON.stringify(roles)
      // localStorage.setItem("roles", rolesJson)
      // this.roles = rolesJson
    },
    getRoles() {
      const storedRoles = localStorage.getItem("roles")
      if (storedRoles) {
        return JSON.parse(storedRoles) // Convert JSON string back to array
      } else {
        return []
      }
      // return ["manager"]
    },    
    setUser(res) {
      this.setToken(res.token)
      this.user = res.user
      localStorage.setItem("user", JSON.stringify(res.user)) // Store user as a string
    },
    clearToken() {
      this.token = ""
      localStorage.removeItem("token")
      localStorage.removeItem("roles")
      localStorage.removeItem("user")
    },
  },
})
